<template>
  <div class="qrcode-dialog-wrap" @click.self="$emit('close')">
    <div class="qrcode-dialog-card">
      <div class="qrcode-dialog-header">
        <div class="qrcode-dialog-back" @click="$emit('close')">
          <svg-icon icon-class="arrow-pre" />
        </div>
        <div class="qrcode-dialog-title">{{ $t("mindmap.qrcodeTitle") }}</div>
      </div>
      <canvas ref="canvasRef" class="qrcode-dialog-canvas"></canvas>
      <div class="qrcode-dialog-url">
        <span class="url-label">URL：</span>{{ shortURLHost }}<span class="url-code">{{ shortCode }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
/*eslint-disable*/
import { ref, onMounted, watch } from 'vue';
import QRCode from 'qrcode';
import SvgIcon from './SvgIcon.vue';

const props = defineProps({
  url: { type: String, required: true },
  shortCode: { type: String, default: '' },
  shortURLHost: { type: String, default: '' },
});

defineEmits(['close']);

const canvasRef = ref(null);

const generate = async () => {
  if (!canvasRef.value || !props.url) return;
  try {
    await QRCode.toCanvas(canvasRef.value, props.url, {
      width: 280,
      margin: 2,
      color: { dark: '#000000', light: '#FFFFFF' },
    });
  } catch (e) {
    console.error('生成 QR Code 失敗:', e);
  }
};

onMounted(generate);
watch(() => props.url, generate);
</script>

<style scoped>
.qrcode-dialog-wrap {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 1004;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}

.qrcode-dialog-card {
  position: relative;
  background-color: #f9f9f9;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  padding: 16px 24px 24px;
  text-align: center;
  width: 100%;
  max-width: 380px;
  max-height: 90vh;
  overflow-y: auto;
  box-sizing: border-box;
}

.qrcode-dialog-header {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin: 8px 0 4px;
}

.qrcode-dialog-back {
  position: absolute;
  left: 0;
  font-size: 24px;
  cursor: pointer;
  color: #30ab9f;
  display: flex;
  align-items: center;
  &:hover { opacity: 0.7; }
}

.qrcode-dialog-title {
  font-size: 20px;
  font-weight: bold;
  color: #333;
}

.qrcode-dialog-canvas {
  display: block;
  margin: 16px auto 8px;
  border: 3px solid #30ab9f;
  border-radius: 8px;
  max-width: 100%;
  height: auto;
}

.qrcode-dialog-url {
  background-color: rgb(255, 245, 202);
  border-radius: 6px;
  padding: 10px 14px;
  margin-top: 12px;
  color: #30ab9f;
  font-weight: bold;
  word-break: break-all;
}

.url-label {
  color: #72767c;
}

.url-code {
  color: #000;
  font-size: 28px;
  background-color: #fff;
  padding: 2px 6px;
  margin-left: 2px;
}
</style>
